// npm install react-pdf pdfjs-dist
import { Document, Page, pdfjs } from "react-pdf";
import { useState } from "react";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

const Comp_Pdf_Viewer_New = (props) => {
  const [numPages, setNumPages] = useState(null);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }
//alert(props.file);
  return (
    <div className="text-center">
      <Document  file={{
    url: props.file,
    withCredentials: false,
  }}
  onLoadSuccess={({ numPages }) => setNumPages(numPages)}
      />
    </div>
  );
};

export default Comp_Pdf_Viewer_New;